import React, { useEffect, useState } from "react";
import fotoSrc from "../../../img/mediakit/lamina03-foto.jpg";
import { getEdificiosListadoPublico, calcularResumenRedComercial } from "../../../utils";
import { BanderaChile } from "./Banderas";
import { Foto } from "./Foto";
import styles from "./Lamina03Crecimiento.module.scss";

// Datos vivos (edificios/pantallas): misma fuente única que /inventario (InventarioAvanzado),
// getEdificiosListadoPublico + calcularResumenRedComercial (src/utils/getResumenRedComercial.js,
// 10.1) — nunca reimplementado acá. Página pública que lee exactamente los mismos datos públicos
// que /inventario ya lee, sin columnas/tablas nuevas (10.279, pre-declarado en el prompt). Wecast
// es contenido de Chile — país fijo, no depende de auth.
// "Objetivo 2027" sigue fijo (no es un dato vivo, es una meta declarada).

function Lamina03Crecimiento() {
  const [resumen, setResumen] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelado = false;
    const cargar = async () => {
      try {
        const edificios = await getEdificiosListadoPublico({ pais: "Chile" });
        if (!cancelado) setResumen(calcularResumenRedComercial(edificios));
      } catch {
        if (!cancelado) setError(true);
      }
    };
    cargar();
    return () => {
      cancelado = true;
    };
  }, []);

  return (
    <div className={styles.lamina} data-mk-lamina="crecimiento">
      <Foto src={fotoSrc} className={styles.foto} data-mk="foto" />

      <div className={styles.panel} data-mk="panel">
        <BanderaChile data-mk="bandera" />

        <div className={styles.stat} data-mk="fila-1">
          <span className={styles.statNumero} data-mk="numero">
            {error ? "—" : (resumen?.totalEdificios ?? "…")}
          </span>
          <span className={styles.statLabel} data-mk="etiqueta">
            Edificios
          </span>
        </div>

        <div className={styles.stat} data-mk="fila-2">
          <span className={styles.statNumero} data-mk="numero">
            {error ? "—" : (resumen?.totalPantallas ?? "…")}
          </span>
          <span className={styles.statLabel} data-mk="etiqueta">
            Pantallas
          </span>
        </div>

        <p className={styles.constante} data-mk="constante">
          ¡Constante crecimiento!
        </p>

        <div className={styles.objetivo} data-mk="objetivo">
          <p className={styles.objetivoTitulo}>Objetivo 2027:</p>
          <ul className={styles.objetivoLista}>
            <li>&gt; 100 edificios</li>
            <li>&gt; 500 pantallas</li>
            <li>&gt; 1.000 empresas</li>
            <li>&gt; 100.000 personas únicas</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Lamina03Crecimiento;
